import { useLocalization } from "@fluent/react";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";
import styles from "./LoanPortalTopNav.module.css";
import { useGetAccessibleApplicationsQuery } from "./useGetAccessibleApplicationsQuery";
import { UserMenu } from "../components/UserMenu/UserMenu";

/**
 * Portal top nav: institution branding and the account menu (with logout).
 *
 * The dashboard has no single application to name the menu from, so it shows the
 * primary applicant's name from the most recently updated accessible application
 * — the same one the dashboard greeting uses. The applications come from the
 * list queries the dashboard already issues (shared react-query cache), so this
 * adds no requests; while they load, the menu is icon-only.
 */
export function LoanPortalTopNav() {
  const { institution } = useGetInstitutionQuery();
  const { l10n } = useLocalization();
  const { data: applications } = useGetAccessibleApplicationsQuery();
  const mostRecentApplication = applications?.[0];

  return (
    <div className={`nds-typography ${styles.topNav}`}>
      <div className={styles.topNavHeading}>
        <img src={institution.logo_url} alt="" role="presentation" />
        <span className={styles.topNavTitle}>
          {l10n.getString("loan-portal-nav-title", null, "My loan applications")}
        </span>
      </div>
      <UserMenu
        firstName={mostRecentApplication?.firstName}
        lastName={mostRecentApplication?.lastName}
      />
    </div>
  );
}
